import React from 'react'

export default function HeroAsset (props) {
  return (
    <svg
      width="404"
      height="461"
      viewBox="0 0 404 461"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M376.879 128.879V429.632H78V69H317L376.879 128.879Z"
        fill="#B0E4EB"
      />
      <g filter="url(#filter0_d_1272_15149)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M359.879 111.879V412.632H61V52H300L359.879 111.879Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.0369 105.039H223.713V112.994H98.0369V105.039Z"
          fill="#D4D7D9"
        />
        <rect
          x="98.0369"
          y="87.8018"
          width="154.781"
          height="9.28098"
          fill="#D4D7D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.0369 148.533H293.828V157.814H98.0369V148.533Z"
          fill="#D4D7D9"
        />
        <rect
          x="98.0369"
          y="166.747"
          width="210.343"
          height="9.28098"
          fill="#D4D7D9"
        />
        <rect
          x="98.0369"
          y="132.141"
          width="239.447"
          height="7.95512"
          fill="#D4D7D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.4232 219.567H308.702V228.674H97.4232V219.567Z"
          fill="#D4D7D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.4232 237.781H308.702V246.888H97.4232V237.781Z"
          fill="#D4D7D9"
        />
        <rect
          x="98.0369"
          y="201.354"
          width="154.781"
          height="9.28098"
          fill="#D4D7D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.0369 317.921H166.828V327.202H98.0369V317.921Z"
          fill="#D4D7D9"
        />
        <rect
          x="98.0369"
          y="281.493"
          width="154.781"
          height="9.28098"
          fill="#D4D7D9"
        />
        <rect
          x="98.0369"
          y="299.707"
          width="154.781"
          height="9.28098"
          fill="#D4D7D9"
        />
        <path
          d="M300 52.0001L300 112.105L360.105 112.105L300 52.0001Z"
          fill="#FCE969"
        />
        <circle cx="191" cy="372" r="9" fill="#5CEBA0" />
        <g clipPath="url(#clip0_1272_15149)">
          <rect
            width="11.3684"
            height="11.3684"
            transform="translate(185.79 366.316)"
            fill="#5CEBA0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M191.453 375.054L197.159 369.349L195.547 367.737L189.841 373.442L187.402 371.003L185.79 372.615L188.229 375.054L188.229 375.055L189.841 376.667L189.841 376.666L189.842 376.667L191.453 375.055L191.453 375.054Z"
            fill="#393E42"
          />
        </g>
        <line x1="182" y1="386.5" x2="309" y2="386.5" stroke="#D4D7D9" />
        <path
          d="M210 368.692C217.696 368.692 227.738 359.576 229.688 357.426C231.639 355.277 237.261 347.47 230.308 350.827C223.355 354.183 208.847 378.292 222.391 378.292C225.908 378.292 228.142 377.881 231.065 375.758C231.43 375.493 235.317 371.936 235.368 372.059C235.419 372.182 236.125 375.055 237.261 376.492C239.088 378.261 240.941 378.892 243.491 378.892C244.833 378.892 246.081 378.75 247.793 377.092C249.164 375.765 249.376 376.169 250.926 376.825C255 378.551 262.692 381.673 267 378.892"
          stroke="#393E42"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
      <mask
        id="mask0_1272_15149"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="317"
        y="250"
        width="87"
        height="115"
      >
        <path
          d="M349.135 358.176C352.541 360.254 356.202 362.488 360.108 364.955C364.014 362.488 367.675 360.254 371.081 358.176C391.888 345.479 403.216 338.565 403.216 319.62V264.37C386.375 264.37 376.254 263.728 360.108 250C343.962 263.728 333.841 264.37 317 264.37V319.62C317 338.565 328.328 345.479 349.135 358.176Z"
          fill="#1D1F21"
        />
      </mask>
      <g mask="url(#mask0_1272_15149)">
        <rect
          x="307.114"
          y="235.171"
          width="53.3809"
          height="151.246"
          fill="#61C9D7"
        />
        <rect x="360" y="235" width="54" height="151" fill="#05AAC0" />
      </g>
      <rect y="215" width="122.628" height="246" rx="14.8991" fill="#393E42" />
      <rect y="215" width="122.628" height="246" rx="14.8991" fill="#393E42" />
      <rect
        x="4.45898"
        y="218.716"
        width="113.71"
        height="238.568"
        rx="12.0612"
        fill="#B0E4EB"
      />
      <path
        d="M37.1602 217.973H86.2115V221.283C86.2115 225.201 83.0351 228.377 79.1167 228.377H44.2549C40.3366 228.377 37.1602 225.201 37.1602 221.283V217.973Z"
        fill="#393E42"
      />
      <rect
        x="22.9023"
        y="320.278"
        width="78.07"
        height="15.5098"
        fill="white"
        stroke="#6F787E"
        strokeWidth="0.709479"
      />
      <rect
        x="29.2473"
        y="325"
        width="35.9142"
        height="5.79261"
        fill="#5CEBA0"
      />
      <rect
        x="22.9023"
        y="354.019"
        width="78.0427"
        height="16.318"
        fill="white"
        stroke="#6F787E"
        strokeWidth="0.709479"
      />
      <rect
        x="22.9023"
        y="388.783"
        width="54.6299"
        height="15.6085"
        fill="white"
        stroke="#6F787E"
        strokeWidth="0.709479"
      />
      <rect
        x="22.2961"
        y="420.714"
        width="47.4994"
        height="13.9023"
        fill="#05AAC0"
      />
      <rect
        x="29.2472"
        y="359.312"
        width="35.9142"
        height="5.79261"
        fill="#5CEBA0"
      />
      <rect
        x="29.2473"
        y="394"
        width="23.1704"
        height="5.79261"
        fill="#5CEBA0"
      />
      <rect x="23.0002" y="313" width="32" height="3" fill="#6F787E" />
      <rect x="23.0002" y="347" width="32" height="3" fill="#6F787E" />
      <rect x="23.0002" y="382" width="22" height="3" fill="#6F787E" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.8365 274.432H60.6163L60.6163 292.054H60.6269C60.6182 292.624 60.5017 293.188 60.2834 293.715C60.0562 294.263 59.7232 294.761 59.3034 295.181C58.8837 295.601 58.3853 295.934 57.8369 296.161C57.2884 296.388 56.7006 296.505 56.1069 296.505C55.5133 296.505 54.9254 296.388 54.377 296.161C53.8285 295.934 53.3302 295.601 52.9104 295.181C52.4906 294.761 52.1577 294.263 51.9305 293.715C51.7033 293.166 51.5864 292.578 51.5864 291.985H49.3771C49.3771 292.868 49.5511 293.744 49.8894 294.56C50.2276 295.377 50.7233 296.119 51.3482 296.743C51.9731 297.368 52.715 297.864 53.5315 298.202C54.348 298.54 55.2231 298.715 56.1069 298.715C56.9907 298.715 57.8658 298.54 58.6823 298.202C59.4988 297.864 60.2407 297.368 60.8656 296.743C61.4906 296.119 61.9863 295.377 62.3245 294.56C62.6538 293.765 62.8275 292.914 62.8364 292.054H62.8365V292.045C62.8367 292.025 62.8368 292.005 62.8368 291.985H62.8365L62.8365 274.432Z"
        fill="#0185A2"
      />
      <rect
        x="60.8573"
        y="245"
        width="1.14286"
        height="4.57143"
        rx="0.571429"
        fill="#0185A2"
      />
      <mask
        id="mask1_1272_15149"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="30"
        y="248"
        width="65"
        height="27"
      >
        <rect
          x="30.0001"
          y="248.429"
          width="64"
          height="26.2857"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask1_1272_15149)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.932 279.554C92.5884 262.332 78.6319 248.478 61.4655 248.478C44.299 248.478 30.3425 262.332 29.9989 279.554L92.932 279.554Z"
          fill="#0185A2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.1198 279.555H74.7432C74.6516 262.328 68.7268 248.429 61.4315 248.429C54.1362 248.429 48.2115 262.328 48.1198 279.555Z"
          fill="#05AAC0"
        />
      </g>
      <rect x="9" width="52" height="52" fill="#61C9D7" />
      <path
        d="M29.6636 31.4688C29.5697 31.4688 29.5088 31.4218 29.4806 31.328L29.0583 29.9486C29.0396 29.9111 29.0161 29.8923 28.988 29.8923H25.5255C25.4973 29.8923 25.4739 29.9111 25.4551 29.9486L25.0469 31.328C25.0188 31.4218 24.9578 31.4688 24.8639 31.4688H23.0764C23.0201 31.4688 22.9779 31.4547 22.9497 31.4265C22.9216 31.389 22.9169 31.3374 22.9356 31.2717L25.9759 21.7569C26.004 21.663 26.065 21.6161 26.1589 21.6161H28.3687C28.4625 21.6161 28.5235 21.663 28.5516 21.7569L31.5919 31.2717C31.6013 31.2905 31.606 31.3139 31.606 31.3421C31.606 31.4265 31.5543 31.4688 31.4511 31.4688H29.6636ZM25.9618 28.2737C25.9524 28.33 25.9712 28.3581 26.0181 28.3581H28.4953C28.5516 28.3581 28.5704 28.33 28.5516 28.2737L27.2849 24.0934C27.2755 24.0558 27.2614 24.0417 27.2426 24.0511C27.2239 24.0511 27.2098 24.0652 27.2004 24.0934L25.9618 28.2737ZM38.5999 21.602C39.2192 21.602 39.7634 21.7287 40.2326 21.9821C40.7018 22.2354 41.0631 22.5967 41.3164 23.0659C41.5791 23.5257 41.7105 24.0558 41.7105 24.6564C41.7105 25.2475 41.5745 25.7683 41.3023 26.2187C41.0396 26.6691 40.6643 27.021 40.1763 27.2743C39.6978 27.5183 39.1441 27.6403 38.5154 27.6403H36.5168C36.4698 27.6403 36.4464 27.6638 36.4464 27.7107V31.2998C36.4464 31.3468 36.4276 31.389 36.3901 31.4265C36.3619 31.4547 36.3244 31.4688 36.2775 31.4688H34.6307C34.5838 31.4688 34.5415 31.4547 34.504 31.4265C34.4759 31.389 34.4618 31.3468 34.4618 31.2998V21.7709C34.4618 21.724 34.4759 21.6865 34.504 21.6583C34.5415 21.6208 34.5838 21.602 34.6307 21.602H38.5999ZM38.3043 26.0498C38.736 26.0498 39.0831 25.9278 39.3459 25.6838C39.6086 25.4305 39.74 25.1021 39.74 24.6986C39.74 24.2857 39.6086 23.9526 39.3459 23.6992C39.0831 23.4459 38.736 23.3192 38.3043 23.3192H36.5168C36.4698 23.3192 36.4464 23.3427 36.4464 23.3896V25.9794C36.4464 26.0263 36.4698 26.0498 36.5168 26.0498H38.3043ZM44.7885 31.4688C44.7416 31.4688 44.6993 31.4547 44.6618 31.4265C44.6336 31.389 44.6196 31.3468 44.6196 31.2998V21.785C44.6196 21.7381 44.6336 21.7006 44.6618 21.6724C44.6993 21.6349 44.7416 21.6161 44.7885 21.6161H46.4353C46.4822 21.6161 46.5197 21.6349 46.5479 21.6724C46.5854 21.7006 46.6042 21.7381 46.6042 21.785V31.2998C46.6042 31.3468 46.5854 31.389 46.5479 31.4265C46.5197 31.4547 46.4822 31.4688 46.4353 31.4688H44.7885Z"
        fill="#1D1F21"
      />
      <defs>
        <filter
          id="filter0_d_1272_15149"
          x="46"
          y="41"
          width="329.105"
          height="390.632"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1272_15149"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1272_15149"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1272_15149">
          <rect
            width="11.3684"
            height="11.3684"
            fill="white"
            transform="translate(185.79 366.316)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
